import { GET_ABOUT_US_INFO, ABOUT_US_INFO_ERROR } from "../types";

const initialState = {
  aboutUsInfo: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ABOUT_US_INFO:
      return {
        ...state,
        aboutUsInfo: action.payload,
        loading: false,
      };
    case ABOUT_US_INFO_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
